export default __webpack_public_path__ + "static/media/phone-mobile.4f8544b1.svg";